module.exports = __webpack_public_path__ + "img/sameday-inactive.e8d839f1.svg";